import { getConversationMessagesQuery } from 'app/graphql';
import { Message } from '../models';
import update from 'immutability-helper';

export const unshiftMessage = (
  data: getConversationMessagesQuery,
  message: Message & { __typename?: string | null }
): getConversationMessagesQuery => {
  if (data?.allMessageConnection?.messages == null) {
    return {
      allMessageConnection: {
        nextToken: null,
        __typename: 'MessageConnection',
        messages: [
          {
            ...message,
            __typename: 'Message',
            senderInfo:
              message.senderInfo == null
                ? null
                : { name: message.senderInfo.name ?? null, email: message.senderInfo.email ?? null },
          },
        ],
      },
    };
  }

  if ((data.allMessageConnection?.messages ?? []).some(m => m?.id === message.id)) {
    return data;
  }

  return update(data, {
    allMessageConnection: {
      // @ts-ignore
      messages: { $unshift: [message] },
    },
  });
};
